import { Box } from '@osmosis/react-ui/components/Box';
import { Children, cloneElement, JSX } from 'react';

/**
 * AccordionItem.
 */
export const AccordionItem = ({
  children,
  index,
}: {
  children: JSX.Element[] | JSX.Element;
  index?: number;
}) => {
  return (
    <Box sx={{ borderBottom: '1px solid black' }}>
      {Children.map(children, (child) => {
        return cloneElement(child, { index, key: index });
      })}
    </Box>
  );
};
